import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetConfigurationDictionariesQuery,
  useLazyGetConfigurationSettingsQuery,
} from '../../store/dictionaries/service';

import { BankRoutes } from '../../routes';

import cn from './bank-and-psp.module.css';

const BankAndPsp = (): React.JSX.Element => {
  const navigate = useNavigate();
  const match = useMatch(BankRoutes.BANK_AND_PSP);

  const { activePermissions, riskScoreRanges, overdraftEnabled } =
    useAppSelector((state) => state.configurationDictionaries);

  const [getDictionaries] = useLazyGetConfigurationDictionariesQuery();
  const [getConfigurationSettings] = useLazyGetConfigurationSettingsQuery();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.SECTION_PSP) &&
      activePermissions.includes(PermissionEnum.PSP_LIST)
    ) {
      if (!riskScoreRanges) {
        getDictionaries();
      }

      if (match) {
        navigate(BankRoutes.BANK_AND_PSP_LIST);
      }

      if (overdraftEnabled === undefined || overdraftEnabled === null) {
        getConfigurationSettings();
      }
    }
  }, [match, activePermissions, riskScoreRanges, overdraftEnabled]);

  useEffect(() => {
    let title = 'Banks';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.bankAndPspLoader}>
      <IconLoader />{' '}
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_PSP) ||
      !activePermissions.includes(PermissionEnum.PSP_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.bankAndPsp}>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default BankAndPsp;
